import { Box, TypographyStylesProvider } from "@mantine/core";
import React from "react";
import { IconArrowBigUpFilled } from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import { JsonView, allExpanded, darkStyles } from "react-json-view-lite";

export const BITCOIN_WITHDRAWALS_CONTENT = (
  <TypographyStylesProvider>
    <p>
      In the history menu, you can see detailed data about Bitcoin withdrawals.
      Note that these are "on-chain" transactions, which means they are settled
      on the Bitcoin blockchain, not via the Lightning Network.
    </p>

    <DocsButton
      ariaLabel="Bitcoin Withdrawals button"
      text="Bitcoin Withdrawals"
      leftSection={<IconArrowBigUpFilled />}
    />

    <p>You will see something like this:</p>
    <Box mb="20px">
      <JsonView
        data={{
          address:
            "tb1pd3n5mku84gznpt4vu5fjddvs70efyz0mhx42c5dphztl40fkqpfs4a6vmj",
          satoshis: 25000,
          transaction_id:
            "60655377c1bb932667be337ce8c27cbee3127c2c55247e09e81b486764feb746",
        }}
        shouldExpandNode={allExpanded}
        style={darkStyles}
      />
    </Box>

    <p>Here’s an explanation of the data fields:</p>
    <ul>
      <li>
        <b>address:</b> The destination Bitcoin address for the withdrawal. In
        this example, the address is{" "}
        <code
          style={{
            wordWrap: "break-word", // Ensures the word wraps to the next line
            wordBreak: "break-word", // Breaks the word if it overflows
            whiteSpace: "normal", // Allows text wrapping
          }}
        >
          tb1pd3n5mku84gznpt4vu5fjddvs70efyz0mhx42c5dphztl40fkqpfs4a6vmj
        </code>
        . This is a Bech32 (native SegWit) address, commonly used for lower fees
        and improved efficiency.
      </li>
      <li>
        <b>satoshis:</b> The amount withdrawn, denominated in satoshis.
      </li>
      <li>
        <b>transaction_id:</b> The unique identifier (TXID) for the Bitcoin
        transaction. This ID is a 64-character hexadecimal string that is unique
        to each transaction. In this example, the TXID is{" "}
        <code
          style={{
            wordWrap: "break-word", // Ensures the word wraps to the next line
            wordBreak: "break-word", // Breaks the word if it overflows
            whiteSpace: "normal", // Allows text wrapping
          }}
        >
          60655377c1bb932667be337ce8c27cbee3127c2c55247e09e81b486764feb746
        </code>
        .
        <ul>
          <li>
            <b>What is a TXID?</b> A TXID is generated when a Bitcoin
            transaction is broadcast to the blockchain. It serves as a unique
            reference for the transaction, allowing it to be tracked and
            verified.
          </li>
          <li>
            <b>How to look it up:</b> You can search for this TXID in any
            Bitcoin blockchain explorer to view details about the transaction,
            such as:
            <ul>
              <li>The sender and receiver addresses</li>
              <li>The amount of Bitcoin sent</li>
              <li>The transaction fee</li>
              <li>The confirmation status and block inclusion</li>
            </ul>
            For example, you could use{" "}
            <a href="https://mempool.space">mempool.space</a> or{" "}
            <a href="https://blockstream.info">Blockstream Explorer</a> for
            testnet or mainnet transactions. Simply copy the TXID and paste it
            into the explorer's search bar.
          </li>
        </ul>
      </li>
    </ul>
  </TypographyStylesProvider>
);
